import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MatSnackBar } from "@angular/material";
import { UserService } from "src/app/services/users/user.service";

@Component({
  selector: "app-restore-password",
  templateUrl: "./restore-password.component.html",
  styleUrls: ["./restore-password.component.scss"],
})
export class RestorePasswordComponent implements OnInit {
  public loader: boolean = false;

  public restorePasswordGroup: FormGroup = new FormGroup({
    email: new FormControl("", [Validators.required, Validators.email]),
  });

  constructor(
    private userService: UserService,
    private snackBar: MatSnackBar,
    private self: MatDialogRef<RestorePasswordComponent>
  ) {}

  ngOnInit() {}

  public requestPasswordReset() {
    this.loader = true;
    this.userService
      .requestPasswordReset({
        email: this.restorePasswordGroup.get("email").value,
      })
      .subscribe(
        (res) => {
          this.snackBar.open("Password reset request sent", "OK", {
            duration: 3000,
          });
          this.loader = false;
          this.self.close(res);
        },
        (err) => {
          this.snackBar.open(err.error.message || "Error requesting password reset", "OK", {
            duration: 8000,
          });
          this.loader = false;
        }
      );
  }
}
